var jsSelectize = {
    /**
     * Init jsSelectize functionalities
     */
    init: function () {
        jsSelectize.initSingle();
        jsSelectize.initMulti();
        jsSelectize.initMultiCreate();
        jsSelectize.initAjax();
        jsSelectize.initTemplate();
    },

    /**
     * Init Selectize for single selection
     */
    initSingle: function () {
        $('.js-selectize--single').each(function () {
            // The default selectize limit is 1000, in our case we have more items.
            // By using a data attribute we can bypass this default setting.
            if ($(this).data('max-options') > 0) {
                $(this).selectize({
                    maxOptions: $(this).data('max-options'),
                    create: false
                });
            }
            else {
                $(this).selectize({
                    create: false
                });
            }
        });
    },

    initTemplate: function () {
        $('.js-selectize--template').each(function () {
            jsSelectize.defineTemplate(this);
        });
    },

    defineTemplate: function (selector) {
        $(selector).selectize({
            create: false,
            render: {
                option: function (item, escape) {
                    return '<div class="choice">' +
                        '<span class="title">' + escape(item.text) + '</span>' +
                        '<span class="description">' + escape(item.help_message) + '</span>' +
                        '</div>';
                }
            }
        });
    },

    /**
     * Init Selectize for single selection
     */
    initAjax: function () {
        $('.js-selectize--ajax').each(function () {
            var resource = $(this).data('resource');
            var maxItems = $(this).data('max-items');
            var item = $(this);

            var field = $(this).selectize({
                plugins: {
                    'no_results': {
                        'message': Translator.trans('message.ajaxNoResultsFound', {}, 'admin')
                    }
                },
                valueField: 'id',
                labelField: 'title',
                searchField: 'title',
                maxItems: maxItems !== undefined ? maxItems : null,
                options: [],
                create: null,
                render: {
                    option: function (item, escape) {
                        return '<div>' + item.title + '</div>';
                    }
                },
                load: function (query, callback) {
                    if (query.length < 3) return callback();

                    var url = resource + '?query=' + encodeURIComponent(query);
                    var parameters = item.attr('data-parameters');
                    if (parameters != undefined && parameters != '') {
                        url = url + '&parameters=' + encodeURIComponent(parameters);
                    }

                    $.ajax({
                        url: url,
                        type: 'GET',
                        error: function () {
                            callback();
                        },
                        success: function (res) {
                            callback(res);
                            if (res.length == 0) {
                                // display no results message
                                item[0].selectize.displayEmptyResultsMessage();
                            }
                        }
                    });
                }
            });

            var initData = $(this).data('value');

            if (initData != undefined && initData != '') {
                var selectize = field[0].selectize;

                selectize.clearOptions();

                $.each(initData, function (index, value) {
                    selectize.addOption(value);
                    selectize.addItem(value.id);
                    selectize.refreshOptions();
                });
            }
        });
    },

    /**
     * Init Selectize for multiple selection
     */
    initMulti: function () {
        $('.js-selectize--multi').each(function () {
            $(this).selectize({
                create: false,
                plugins: {
                    'remove_button': {
                        title: 'remove'
                    }
                }
            });
        });
    },

    /**
     * Init Selectize for multiple selection
     */
    initMultiCreate: function () {
        $('.js-selectize--multi-create').each(function () {
            $(this).selectize({
                create: true,
                plugins: {
                    'remove_button': {
                        title: 'remove'
                    }
                }
            });
        });
    }
};
